module.exports = __webpack_public_path__ + "img/bg.ec574033.jpg";